import { BoardSearchProps } from '../boardItem'
import '../boardMobile.css'
export const BoardSearchMobile: React.FC<BoardSearchProps> = ({
  handleSearch,
  handleKeyDown,
  handleSearchSubmit,
  srchData,
}) => {
  return (
    <div className="mobile-search-container">
      <input
        type="text"
        id="srchStr"
        name="srchStr"
        className="mobile-search-input"
        placeholder="검색어를 입력하세요"
        value={srchData.srchStr}
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
      />
      <div className="mobile-search-row">
        <select
          id="srchOpt"
          name="srchOpt"
          className="mobile-search-select"
          value={srchData.srchOpt}
          onChange={handleSearch}
        >
          <option value="01">제목</option>
          <option value="02">내용</option>
          <option value="03">작성자</option>
          <option value="04">제목+내용</option>
        </select>
        <button className="mobile-search-btn" onClick={handleSearchSubmit}>
          검색
        </button>
      </div>
    </div>
  )
}
